module.exports = __webpack_public_path__ + "img/refuse.720e875a.png";